import {useEffect} from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {FooterBar} from 'shells/modal/footer-bar';
import {Modal} from 'shells/modal/modal';

import {analyticsClient} from '../../../../analytics-client';

interface Props {
    children: React.ReactNode;
    handleSave: () => void;
    handleSaveAndResearch: () => void;
    isDisabled: boolean;
    isOnboarding: boolean;
    isOpen: boolean;
    onClose: () => void;
}

export function LeadResearcherSetUpModal(props: Props) {
    useEffect(() => {
        if (props.isOpen) {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_LEAD_RESEARCHER_SETTINGS_VIEWED, {
                isOnboarding: props.isOnboarding,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isOpen]);

    return (
        <Modal
            closeButtonColor={colors.aiPurplePink}
            headerBackgroundColor={colors.aiPurplePinkLt}
            headerIllustration={() => <Illustration src='lead-researcher-header' />}
            headerSubtext={
                props.isOnboarding
                    ? 'Share a few details about your business so our researcher can deliver more accurate results.'
                    : 'Fine-tune your criteria so our researcher can deliver more accurate results.'
            }
            headerText='Set up your lead researcher'
            isOpen={props.isOpen}
            maxWidth={650}
            noTopPadding={true}
            onClose={props.onClose}
        >
            {props.children}
            <FooterBar
                hasBorder={true}
                fitHeight={true}
                left={
                    <Button variant='text-secondary' size='normal' onClick={props.onClose}>
                        Close
                    </Button>
                }
                right={
                    <Stack isHorizontal={true} spacing={8}>
                        {!props.isOnboarding && (
                            <Button
                                variant='ai-purple-light'
                                size='big'
                                onClick={props.handleSave}
                                disabled={props.isDisabled}
                            >
                                Save
                            </Button>
                        )}
                        <Button
                            variant='ai-purple-dark'
                            size='big'
                            onClick={props.handleSaveAndResearch}
                            disabled={props.isDisabled}
                        >
                            Save and research
                        </Button>
                    </Stack>
                }
            />
        </Modal>
    );
}
